var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Iconfont',{attrs:{"size":18,"name":"icon-chezu","mRight":7}})
}
var staticRenderFns = []

export { render, staticRenderFns }